import _ from 'underscore';

/**
 * Formats a text to a lmm css className.
 * @memberof core.helpers
 * @param {String} text - The text to format
 */
function formatCssClass(text) {
  let prefix = 'lmm-',
    textLowerCase = [];
  _.each(text.split(/(?=[A-Z])/), (e) => {
    textLowerCase.push(e.toLowerCase());
  });
  return prefix + textLowerCase.join('-');
}

export default formatCssClass;



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/formatCssClass.js